import React, { useState } from 'react';
import { Investigator } from '../api';
import '../styles/Map.css';

const INVESTIGATOR_TOKENS_BASE_PATH = '/Investigators/tokens';

const getInvestigatorTokenImagePath = (investigatorName: string) => {
  return `${INVESTIGATOR_TOKENS_BASE_PATH}/${encodeURIComponent(investigatorName)}.jpg`;
};

export interface InvestigatorMarkerProps {
  investigator: Pick<Investigator, 'name' | 'delayed' | 'isDevoured'>;
  size?: number;
  highlighted?: boolean;
  scale?: number;
  idx?: number;
  offsetByIndex?: boolean;
  onClick?: () => void;
}

export const InvestigatorMarker: React.FC<InvestigatorMarkerProps> = ({
  investigator,
  size,
  highlighted = false,
  scale = 1,
  idx = 0,
  offsetByIndex = true,
  onClick,
}) => {
  const [imageFailed, setImageFailed] = useState(false);
  const highlightColor = highlighted ? '74, 222, 128' : '63, 243, 226';
  const style: React.CSSProperties = {
    width: size ? `${size}px` : undefined,
    height: size ? `${size}px` : undefined,
    zIndex: 100 + idx,
    transform: offsetByIndex ? `translateX(${idx * 20 * scale}px)` : undefined,
    boxShadow: `0 0 ${4 * scale}px ${4 * scale}px rgba(${highlightColor}, 0.9), 0 0 ${6 * scale}px rgba(${highlightColor}, 0.8)`,
    borderColor: `rgb(${highlightColor})`,
    cursor: `${!!onClick ? 'pointer' : 'unset'}`
  };

  return (
    <div
      className={`investigator-marker${highlighted ? ' investigator-marker-highlighted' : ''}`}
      title={investigator.name}
      style={style}
      onClick={onClick}
    >
      {!imageFailed ? (
        <img loading="lazy"
          src={getInvestigatorTokenImagePath(investigator.name)}
          alt={`${investigator.name} token`}
          className="investigator-token-image"
          onError={() => setImageFailed(true)}
        />
      ) : (
        <span className="investigator-initial">{investigator.name.charAt(0)}</span>
      )}
      {investigator.delayed && <span className="investigator-marker-status">Delayed</span>}
      {investigator.isDevoured && <span className="investigator-marker-status">Devoured</span>}
    </div>
  );
};
